<template>
    <div>
        <ul class="group-show-child-lists fa-ul">
            <design-2021-apprentice-tree-view-node-component
                    v-for="obj in data"
                    :obj-in="obj"
                    :children="children"
                    :key="obj.id"
                    :indent-in="indent"
                    :navigate-to-element="navigateToElement"
					@open="openList"
                    :open-in="true">
            </design-2021-apprentice-tree-view-node-component>
        </ul>
    </div>
</template>

<script>
    export default {
        name: "design-2021-apprentice-tree-view-component",
        props: {
            'data': {
                required: true
            },
            'children': {
                default: 'children'
            },
            'indent': {
                required: true
            },
            navigateToElement: {
                default: true
            }
        },
        methods: {
            openList () {
                this.$emit('open');
            }
        }
    }
</script>

<style scoped lang="scss">
    .group-show-child-lists {
        margin-left: 0;
        font-size: $default-font-size;

        li:first-child {
            .fa-li-name {
                padding-left: 0;
            }
        }
    }
</style>
